<div class="container">
  <p class="text">{{"GENERAL.START_RENTING" | translate}}</p>
  <div class="btn">
    <hf-text-button [text]="translate.get('GENERAL.JOIN_NOW') | async" hfColor="darkgreen-btn"
                    styleType="primary" (click)="goToRegistration()" [height]="'48px'"></hf-text-button>
  </div>
</div>

